module.exports = __webpack_public_path__ + "static/media/empty_faq.76db71cc.svg";